<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<crucible-dialog
  [dialogTitle]="data?.teamType?.id ? 'Edit Team Type' : 'Add Team Type'"
  [form]="form"
  submitLabel="Save"
  [submitDisabled]="!form.valid || !form.dirty || !data.canEdit"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
@if (data && data.teamType) {
  <div crucibleDialogContent [formGroup]="form">
    <div class="add-margin">
      <div>
        <mat-form-field class="name-field full-width">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-checkbox formControlName="isOfficialScoreContributor">
          Official Score Contributor
        </mat-checkbox>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-checkbox formControlName="showTeamTypeAverage">
          Show TeamType Average
        </mat-checkbox>
      </div>
    </div>
  </div>
}
</crucible-dialog>
